import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import XIcon from '@heroicons/react/outline/XIcon';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { FileDropZone } from '@tribeplatform/react-ui-kit/FileUpload';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { List } from '@tribeplatform/react-ui-kit/Layout';
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip';
import { FileListItem } from '../../common/components/FileListItem';
import { fileSizeLimitError } from '../../common/lib/upload';
import { T, useI18n } from '../../i18n';
import { useHandleUploadableFiles } from './useHandleUploadableFiles';
const isMultiple = (props) => props.multiple === true;
export const FormFileUpload = (props) => {
    const intl = useI18n();
    const { $t } = intl;
    const { onError, ...rest } = props;
    const multiple = isMultiple(props);
    let defaultValue;
    if (multiple) {
        defaultValue = props.value || [];
    }
    else {
        defaultValue = props.value ? [props.value] : [];
    }
    const { data: network } = useNetwork();
    const { fileTypesLimit, fileSizeLimit } = (network === null || network === void 0 ? void 0 : network.settings) || {};
    const onSuccess = newValue => {
        var _a, _b;
        if (multiple) {
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, newValue);
        }
        else {
            (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, newValue === null || newValue === void 0 ? void 0 : newValue[0]);
        }
    };
    const { files, onFileUpload, onRemove } = useHandleUploadableFiles({
        defaultValue,
        multiple,
        onChange: onSuccess,
        onError,
    });
    const fileUpload = !(files === null || files === void 0 ? void 0 : files.length) && (_jsx(FileDropZone.Label, { actionTitle: multiple
            ? $t({
                defaultMessage: 'Click to upload files, or drag and drop them here.',
                id: 'Form.File.UploadManyFiles',
            })
            : $t({
                defaultMessage: 'Click to upload a file, or drag and drop it here.',
                id: 'Form.File.UploadAFile',
            }), actionHint: fileSizeLimitError(fileSizeLimit, 'file', intl) }, void 0));
    const uploadedFiles = (files === null || files === void 0 ? void 0 : files.length) > 0 && (_jsx(List, { spacing: "sm", className: "p-4", children: files.map(file => (_jsx(List.Item, { children: _jsx(FileListItem, { name: file.name, extension: file === null || file === void 0 ? void 0 : file.extension, size: file === null || file === void 0 ? void 0 : file.size, downloadUrl: (file === null || file === void 0 ? void 0 : file.downloadUrl) || (file === null || file === void 0 ? void 0 : file.url), action: _jsx("div", { className: "flex items-center space-s-3", children: file.isLoading ? (_jsx(SpinnerIcon, { className: "animate-spin w-7 h-7" }, void 0)) : (_jsxs(Tooltip, { children: [_jsx(Tooltip.Trigger, { children: _jsx(XIcon, { onClick: e => {
                                        e.stopPropagation();
                                        onRemove(file);
                                    }, className: "text-content-subdued hover:text-content-hovered cursor-pointer w-6 h-6" }, void 0) }, void 0), _jsx(Tooltip.Panel, { children: _jsx(T, { id: "Generics.Delete", defaultMessage: "Delete" }, void 0) }, void 0)] }, void 0)) }, void 0) }, void 0) }, file.name))) }, void 0));
    return (_jsxs(FileDropZone, { onDrop: onFileUpload, allowMultiple: multiple, accept: fileTypesLimit === null || fileTypesLimit === void 0 ? void 0 : fileTypesLimit.join(','), ...rest, children: [fileUpload, uploadedFiles] }, void 0));
};
//# sourceMappingURL=FormFileUpload.js.map